<template>
  <v-alert v-if="isGrundData" outlined type="success" text>
    <div class="g-row">
      Denna sida är fastnålad.
      <v-btn text @click="onRemove">Ta bort</v-btn>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: 'PageGrundData',
  props: {
    value: { type: Object },
  },
  computed: {
    isGrundData() {
      return 'grunddata' in this.value && this.value.grunddata
    },
  },
  methods: {
    onRemove() {
      const payload = { ...this.value, grunddata: false }
      this.$emit('input', JSON.stringify(payload))
    },
  },
}
</script>

<style lang="less" scoped>
.g-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
